import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Steps, Table } from "antd";
import "./index.scss";
import toastr from "toastr";
import { getRequest } from "../../api/http";
import caService from "../../api/caService";
import caBanner from "../../assets/images/ca_banner.png";
import home from "../../assets/images/home_ca.png";

const HomeCA = () => {
  const navigate = useNavigate();
  const [levels, setLevels] = useState([]);
  const [current, setCurrent] = useState(0);
  const [verticalCurrent, setVerticalCurrent] = useState(0);
  const [expandedStep, setExpandedStep] = useState(0);
  const [clickedLevel, setClickedLevel] = useState(null);

  const getLevels = async () => {
    try {
      const response = await getRequest(caService.getLevels());
      setLevels(response);
      const ongoingIndex = response.findIndex(
        (level) => level.status === "ONGOING"
      );
      if (ongoingIndex !== -1) {
        setCurrent(ongoingIndex);
      }
    } catch (error) {
      toastr.error(error.message);
    }
  };

  useEffect(() => {
    getLevels();
  }, []);

  const handleStepClick = (index) => {
    setVerticalCurrent(index);
    setExpandedStep(expandedStep === index ? null : index);
  };
  const horizantalStepClick = (index) => {
    setCurrent(index);
    setClickedLevel(index);

  };


  const handleLevelClick = (status, id, name, stage) => {
    navigate("/tasks", {
      state: { levelId: id, levelName: name, levelStage: stage },
    });
  };

  const levelTypeToLabel = (type) => {
    const mapping = {
      LEVEL_ONE: "Level 1",
      LEVEL_TWO: "Level 2",
      LEVEL_THREE: "Level 3",
      LEVEL_FOUR: "Level 4",
      LEVEL_FIVE: "Level 5",
      LEVEL_SIX: "Level 6",
    };

    return mapping[type] || "Level";
  };

  const items = levels.map((level,index) => ({
    title: level.name,
    icon: (
      <div className="levels-icon-container">
        <img src={level.iconUrl} alt="Level 1 Icon" />
      </div>
    ),
    className: `step-${level.status} ${
      clickedLevel !== null && clickedLevel > index && clickedLevel <= current
        ? "step-clicked"
        : ""
    }`,
  }));

  const columns = [
    {
      title: "Reward Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
  ];
  return (
    <>
      <div className="course-levels">
        <div className="dummy">
          <img src={home} alt="Banner" className="dummy-image" />
        </div>
        <div className="steps-container">
          <Steps
            current={current}
            items={items}
            onChange={horizantalStepClick}
          />
          {levels[current] && (
            <div
              className={`level-card ${levels[current].levelUnlocked}`}
              onClick={() =>
                handleLevelClick(
                  levels[current].levelUnlocked,
                  levels[current].id,
                  levels[current].name,
                  levels[current].stage
                )
              }
            >
              <h2></h2>
              <p>{levels[current].description}
              <span className="view-more"> View more</span></p>
            </div>
          )}
        </div>
        <div className="heading" style={{ color: "black" }}>
          The rewards you earn!!
        </div>
        <div className="vertical-steps-container">
          <Steps
            current={verticalCurrent}
            onChange={handleStepClick}
            direction="vertical"
          >
            {levels.map((level, index) => (
              <Steps.Step
                key={index}
                title={<>{level.name}</>}
                icon={
                  <div className="levels-icon-container">
                    <img src={level.iconUrl} alt={level.name} />
                  </div>
                }
                status={expandedStep === index ? "process" : "wait"}
                onClick={() => handleStepClick(index)}
                description={
                  <>
                    {expandedStep === index ? (
                      <>
                        <div>
                          <Table
                            columns={columns}
                            dataSource={level.rewardOutput}
                            pagination={false}
                            rowKey="id"
                          />
                        </div>
                      </>
                    ) : null}
                  </>
                }
              />
            ))}
          </Steps>
        </div>
      </div>
    </>
  );
};

export default HomeCA;
